export const NaturalBlue = ({
  className,
  accent1,
  accent2,
}: {
  className?: string;
  accent1?: string;
  accent2?: string;
}) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="192"
    viewBox="0 0 32 192"
    fill="none"
  >
    <g clipPath="url(#clip0_3736_5221)">
      <rect width="32" height="192" fill={accent1} />
      <path d="M0 160L-1.57361e-06 192L34 192" fill={accent2} />
      <path d="M32 160L32 192L-2 192" fill={accent2} />
    </g>
    <defs>
      <clipPath id="clip0_3736_5221">
        <rect width="32" height="192" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
